<div class="row">
    <div class="col-7 mb-3">
        <h2 class="title-list">List of Partners</h2>
    </div>
    <div class="col-2 text-end">
        <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalTransfer" *ngIf="permissionsService.editPermission" [disabled]="!isAnyCheckboxSelectedPartnerCustomer">
            Transfer Partners
        </button>
    </div>
    <div class="col-2 text-end">
        <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalAssign" *ngIf="permissionsService.editPermission">
            Assign Partners
        </button>
    </div>
    <div class="col-1 text-end">
      <button class="btn btn-secondary" (click)="exportToExcelListDistributorPartners()">
        <i class="bi bi-file-earmark-excel"></i>
      </button>
    </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="input-group mb-3">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control input-label" placeholder="Search"
        [(ngModel)]="textoBusqueda" (input)="onSearchChange()" />
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="table-responsive rounded-5">
      <table class="table table-striped mb-0">
        <caption class="d-none">List of partners and their details</caption>
        <thead class="head-table">
          <tr>
            <th class="px-4 py-3 align-middle">
              <input type="checkbox" (change)="selectAllCheckboxesPartnerCustomer($event)" />
            </th>
            <th class="px-4 py-3 align-middle">Partner Account</th>
            <th class="px-4 py-3 align-middle">Name</th>
            <th class="px-4 py-3 align-middle">Email</th>
            <th class="px-4 py-3 align-middle">Contact Number</th>
            <th class="px-4 py-3 align-middle"># Plans</th>
            <th class="px-4 py-3 align-middle">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let partner of partners | search : textoBusqueda : camposBusqueda
              | slice : (currentPage - 1) * 10 : currentPage * 10">
            <td class="px-4 py-3 align-middle">
              <input type="checkbox" [(ngModel)]="partner.checked" (change)="checkboxChangedPartnerCustomer()" />
            </td>
            <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
              {{ partner.customerAccount }}
            </td>
            <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                @if (this.permissionsService.partners.readPermission || this.permissionsService.partners.editPermission){
                <a link (click)="navigateToPartner(partner)">{{ partner.userNames }}</a>
                } @else {
                {{ partner.userNames }}
                }
            </td>
            <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
              {{ partner.userMail }}
            </td>
            <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
              {{ partner.userPhone }}
            </td>
            <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
              {{ partner.numberPlans }}
            </td>
            <td class="px-4 py-3 align-middle">
              <div *ngIf="partner.userStatus === 0 || partner.userStatus === 1" class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [checked]="partner.userStatus === 1" disabled />
              </div>
              <div *ngIf="partner.userStatus === 2">
                <span class="archived">Archived</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="row d-flex align-items-center justify-content-between">
  <div class="col-2">
    <label>
      Showing {{ (currentPage - 1) * recordsPerPage + 1 }} to
      {{ currentPage * recordsPerPage < partners.length ? currentPage * recordsPerPage : partners.length }}
      out of {{ partners.length }} entries
    </label>
  </div>
  <div class="col-7">
    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li class="page-item" [class.disabled]="currentPage === 1">
          <a class="page-link" href="javascript:void(0)" (click)="previousPage()">
            <i class="bi bi-chevron-left"></i>
          </a>
        </li>
        <ng-container *ngFor="let page of pages">
          <li class="page-item" [class.active]="page === currentPage">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
          </li>
        </ng-container>
        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
            <i class="bi bi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>

<!-- Modal Assign Partners -->
<div class="modal fade" id="modalAssign" tabindex="-1" aria-labelledby="modalAssignLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modal-titles" id="modalAssignLabel" style="font-weight: bold;">Assign Partners</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="assignPartners(false)"></button>
      </div>
      <div class="modal-body">
        <div class="mb-4">
          Please select the partners you want to assign to this distributor.
        </div>
        <div class="col-12">
          <div class="input-group mb-3">
            <span class="input-group-text"><i class="bi bi-search"></i></span>
            <input type="text" class="form-control input-label" placeholder="Search"
              [(ngModel)]="textoBusquedaAssignPartner" (input)="onSearchChangeAvailables()" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="table-responsive rounded-5">
              <table class="table table-striped mb-0">
                <caption class="d-none">List of available partners</caption>
                <thead class="head-table">
                  <tr>
                    <th class="px-4 py-3 align-middle">
                      <input type="checkbox" (change)="selectAllCheckboxes($event)" />
                    </th>
                    <th class="px-4 py-3 align-middle">Partner Account</th>
                    <th class="px-4 py-3 align-middle">Name</th>
                    <th class="px-4 py-3 align-middle">Email</th>
                    <th class="px-4 py-3 align-middle">Contact Number</th>
                    <th class="px-4 py-3 align-middle"># Plans</th>
                    <th class="px-4 py-3 align-middle">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let partner of partnersAvailables
                      | searchModal : textoBusquedaAssignPartner : camposBusqueda
                      | slice : (currentPageAvailables - 1) * 10 : currentPageAvailables * 10">
                    <td class="px-4 py-3 align-middle">
                      <input type="checkbox" [(ngModel)]="partner.checked" (change)="checkboxChanged()" />
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                      {{ partner.customerAccount }}
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                      {{ partner.userNames }}
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                      {{ partner.userMail }}
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                      {{ partner.userPhone }}
                    </td>
                    <td class="px-4 py-3 align-middle" [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'">
                      {{ partner.numberPlans }}
                    </td>
                    <td class="px-4 py-3 align-middle">
                      <div *ngIf="partner.userStatus === 0 || partner.userStatus === 1" class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" [checked]="partner.userStatus === 1" disabled />
                      </div>
                      <div *ngIf="partner.userStatus === 2">
                        <span class="archived">Archived</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row d-flex align-items-center justify-content-between">
          <div class="col-3">
            <label>
              Showing {{ (currentPageAvailables - 1) * recordsPerPage + 1 }} to
              {{ currentPageAvailables * recordsPerPage < partnersAvailables.length ? currentPageAvailables * recordsPerPage : partnersAvailables.length }}
              out of {{ partnersAvailables.length }} entries
            </label>
          </div>
          <div class="col-7">
            <nav aria-label="Page navigation">
              <ul class="pagination">
                <li class="page-item" [class.disabled]="currentPageAvailables === 1">
                  <a class="page-link" href="javascript:void(0)" (click)="previousPageAvailables()">
                    <i class="bi bi-chevron-left"></i>
                  </a>
                </li>
                <ng-container *ngFor="let pageAv of pageAvailables">
                  <li class="page-item" [class.active]="pageAv === currentPageAvailables">
                    <a class="page-link" href="javascript:void(0)" (click)="changePageAvailables(pageAv)">{{ pageAv }}</a>
                  </li>
                </ng-container>
                <li class="page-item" [class.disabled]="currentPageAvailables === totalPagesAvailables">
                  <a class="page-link" href="javascript:void(0)" (click)="nextPageAvailables()">
                    <i class="bi bi-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="assignPartners(false)">Cancel</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="assignPartners(true)"
          [disabled]="!isAnyCheckboxSelected">
          Assign Partners
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Transfer Partners -->
<div class="modal fade" id="modalTransfer" tabindex="-1" aria-labelledby="modalTransferLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modal-titles" id="modalTransferLabel" style="font-weight: bold;">Transfer Partners</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="transferPartners(false)"></button>
      </div>
      <div class="modal-body">
        <div class="mb-4">Please select the new Distributor:</div>
        <div class="col-12">
          <div class="input-group mb-3">
            <span class="input-group-text"><i class="bi bi-search"></i></span>
            <input type="text" class="form-control input-label" placeholder="Search"
              [(ngModel)]="textoBusquedaTransferPartner" (input)="onSearchChangeDistributorAvailables()" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="table-responsive rounded-5">
              <table class="table table-striped mb-0">
                <caption class="d-none">List of distributors</caption>
                <thead class="head-table">
                  <tr>
                    <th class="px-4 py-3 align-middle"></th>
                    <th class="px-4 py-3 align-middle">Distributor ID</th>
                    <th class="px-4 py-3 align-middle">Name</th>
                    <th class="px-4 py-3 align-middle">Email</th>
                    <th class="px-4 py-3 align-middle">Contact Number</th>
                    <th class="px-4 py-3 align-middle">Total Partners</th>
                    <th class="px-4 py-3 align-middle">Total Customers</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dist of distributorsAvailables
                      | searchModal : textoBusquedaTransferPartner : camposBusquedaAvailables
                      | slice : (currentPageDistributorAvailables - 1) * 10 : currentPageDistributorAvailables * 10">
                    <td class="px-4 py-3 align-middle">
                      <input type="checkbox" [(ngModel)]="dist.checked" (change)="checkboxChangedTransfer(dist)" />
                    </td>
                    <td class="px-4 py-3 align-middle">{{ dist.idPartner }}</td>
                    <td class="px-4 py-3 align-middle">{{ dist.namePartner }}</td>
                    <td class="px-4 py-3 align-middle">{{ dist.mailPartner }}</td>
                    <td class="px-4 py-3 align-middle">{{ dist.phone }}</td>
                    <td class="px-4 py-3 align-middle">{{ dist.totalPartners }}</td>
                    <td class="px-4 py-3 align-middle">{{ dist.totalCustomers }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row d-flex align-items-center justify-content-between">
          <div class="col-3">
            <label>
              Showing {{ (currentPageDistributorAvailables - 1) * recordsPerPage + 1 }} to
              {{ currentPageDistributorAvailables * recordsPerPage < distributorsAvailables.length ? currentPageDistributorAvailables * recordsPerPage : distributorsAvailables.length }}
              out of {{ distributorsAvailables.length }} entries
            </label>
          </div>
          <div class="col-7">
            <nav aria-label="Page navigation">
              <ul class="pagination">
                <li class="page-item" [class.disabled]="currentPageDistributorAvailables === 1">
                  <a class="page-link" href="javascript:void(0)" (click)="previousPageDistributorAvailables()">
                    <i class="bi bi-chevron-left"></i>
                  </a>
                </li>
                <ng-container *ngFor="let page of pageDistributorAvailables">
                  <li class="page-item" [class.active]="page === currentPageDistributorAvailables">
                    <a class="page-link" href="javascript:void(0)" (click)="changePageDistributorAvailables(page)">{{ page }}</a>
                  </li>
                </ng-container>
                <li class="page-item" [class.disabled]="currentPageDistributorAvailables === totalPagesDistributorAvailables">
                  <a class="page-link" href="javascript:void(0)" (click)="nextPageDistributorAvailables()">
                    <i class="bi bi-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="transferPartners(false)">Cancel</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="transferPartners(true)"
          [disabled]="!isAnyCheckboxSelectedTransfer">
          Transfer Partners
        </button>
      </div>
    </div>
  </div>
</div>
